import React from 'react';
import { Modal, Heading, ModalMobileLayout } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../../CommunityNavSubHeader.dataHooks';
import CommunityNavModalMainScreen from '../CommunityNavModalMainScreen/CommunityNavModalMainScreen';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CommunityNavModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      zIndex={10000}
      isOpen={isOpen}
      screen="full"
      onRequestClose={onClose}
    >
      <ModalMobileLayout
        fullscreen
        dataHook={communityNavSubHeaderDataHooks.mobileModal()}
        title={
          <Heading size="medium" as="h3">
            {t('marketplace.community-nav-sub-header.title')}
          </Heading>
        }
        onCloseButtonClick={onClose}
        content={<CommunityNavModalMainScreen />}
      />
    </Modal>
  );
};

export default CommunityNavModal;
